import { AuthError, User } from '@supabase/supabase-js';
import { useMutation } from '@tanstack/react-query';

import { supabaseClient } from '../../auth/supabase';
import { UserDataFormValues } from '../../features/details-form/types';
import { buildUser } from '../../utils/build-user';
import { queryRetry } from '../query-retry';

export const useUpdateUserMetadata = () =>
    useMutation<
        User,
        AuthError,
        { userValues: UserDataFormValues; isSpanishTaxApplicable: boolean }
    >({
        mutationKey: ['update-user-metadata'],
        mutationFn: async ({ userValues, isSpanishTaxApplicable }) => {
            const userData = buildUser(userValues, { isSpanishTaxApplicable });

            const { data, error } = await supabaseClient.auth.updateUser({
                data: userData,
            });

            if (error) throw error;

            return data.user;
        },
        retry: queryRetry,
    });
